import { GridFilterInputValue, GridFilterInputSingleSelect } from "@mui/x-data-grid";
import { FilterOperators } from "../../../components";
import { parseFilter, stringifyFilter } from "../../../utils";
import queryString from "query-string";
const buildCustomOperators = (filterOperators, i18n, InputComponent) => {
  return (filterOperators || []).map(({
    id,
    name
  }) => {
    return {
      label: i18n`${id}`,
      value: name,
      getApplyFilterFn: () => null,
      // Only needed when filtering local
      InputComponent
    };
  });
};
const buildFilterOperators = (type, i18n) => {
  switch (type) {
    case "singleSelect":
      const singleSelectOperators = FilterOperators["singleSelect"];
      return buildCustomOperators(singleSelectOperators, i18n, GridFilterInputSingleSelect);
    case "number":
      // TODO to be implemented
      break;
    case "date":
      // TODO to be implemented
      break;
    default:
      const stringOperators = FilterOperators["string"];
      return buildCustomOperators(stringOperators, i18n, GridFilterInputValue);
  }
};
export const buildURLFilters = (filterItems, availableFilters) => {
  let output = [];
  (filterItems || []).forEach(item => {
    const {
      operator,
      field,
      value
    } = item;
    let filterFound = (availableFilters || []).find(availableF => availableF.name === field);
    if (!filterFound) {
      return;
    }
    let existing = output.find(el => el.column === filterFound.prop);
    if (!existing && value) {
      existing = {
        column: filterFound.prop,
        filters: [],
        operator: operator,
        columnHeader: field
      };
      output.push(existing);
    }
    if (value) {
      existing.filters.push({
        value: item.value
      });
    }
  });
  return output;
};
export const loadURLFilters = searchUrl => {
  const queryParams = queryString.parse(searchUrl);
  if (!queryParams?.filter) {
    return [];
  }
  const filterParsed = parseFilter(queryParams.filter);
  const datagridFilters = [];
  (filterParsed || []).map(filterItem => {
    (filterItem.filters || []).map(filter => {
      if (!filter.value) {
        return;
      }
      datagridFilters.push({
        field: filterItem.columnHeader,
        operator: filterItem.operator,
        value: filter.value
      });
    });
  });
  return datagridFilters;
};
export const buildFilter = (filter, i18n) => {
  const {
    type,
    column,
    name,
    table,
    disableOperators,
    mandatory,
    mask,
    list
  } = filter;
  const filterObject = {
    filterable: true
  };

  // TODO to be implemented
  switch (type) {
    case "Int":
      break;
    case "Date":
      break;
    case "String":
      break;
    case "Like":
      break;
    case "Autosearch":
      filterObject.type = "singleSelect";
      filterObject.valueOptions = generateValueOptions(list, i18n);
      break;
    default:
      break;
  }
  filterObject.filterOperators = buildFilterOperators(filterObject.type, i18n);
  return filterObject;
};
const generateValueOptions = (items, i18n) => {
  return (items || []).map(item => {
    return {
      value: item,
      label: i18n`${item}`
    };
  });
};
export const buildAvailableFilters = (availableFilters, columnsObj, i18n) => {
  const notVisibleColumns = {};
  const columnsWithFilters = {
    ...columnsObj
  };
  (availableFilters || []).forEach(item => {
    if (columnsWithFilters[item.name]) {
      const filter = buildFilter(item, i18n);
      columnsWithFilters[item.name] = {
        ...columnsWithFilters[item.name],
        disableColumnMenu: false,
        ...filter
      };
    } else {
      columnsWithFilters[item.name] = {
        field: item.name
      };
      notVisibleColumns[item.name] = false;
    }
  });
  return {
    notVisibleColumns,
    columnsWithFilters
  };
};
export const applyFiltersToUrl = (filterItems, availableFilters, history) => {
  const urlFilters = buildURLFilters(filterItems, availableFilters);
  const queryParams = queryString.parse(location.search);
  if (!urlFilters?.length) {
    if (queryParams.filter) {
      delete queryParams.filter;
      history.replace({
        search: queryString.stringify({
          ...queryParams
        })
      });
    }
    return;
  }
  const filterString = stringifyFilter(urlFilters);
  if (queryParams?.filter === filterString) {
    return;
  }
  history.replace({
    search: queryString.stringify({
      ...queryParams,
      filter: filterString
    })
  });
};
export const filterColumns = ({
  field,
  columns,
  currentFilters
}) => {
  const filteredFields = (currentFilters || []).map(item => item.field);
  return (columns || []).filter(colDef => colDef.filterable && (colDef.field === field || !filteredFields.includes(colDef.field))).map(column => column.field);
};
export const getColumnForNewFilter = ({
  currentFilters,
  columns
}) => {
  const filteredFields = (currentFilters || []).map(({
    field
  }) => field);
  const columnForNewFilter = (columns || []).filter(colDef => colDef.filterable && !filteredFields.includes(colDef.field)).find(colDef => colDef.filterOperators?.length);
  return columnForNewFilter?.field ?? null;
};